import React, { CSSProperties } from 'react'
import { IconType } from './design-constants'
import IconHeader from './icon-header'

type Props = {
   iconType: IconType
   headerText: string
   explanation: string
   style?: CSSProperties
}

const IconHeaderBlock = (props: Props) => {
   return (
      <div style={props.style}>
         <IconHeader headerText={props.headerText} iconType={props.iconType} />
         <div>
            <div className="ml-[55px] mt-[10px] text-[#1f1f1f] max-w-[700px] leading-[1.5]">
               <span dangerouslySetInnerHTML={{ __html: props.explanation }} />
               {'.'}
            </div>
         </div>
      </div>
   )
}

export default IconHeaderBlock
